import React from "react";
import { useDispatch } from "react-redux";
import { ClearFilters } from "../../../components/filters/ClearFilters";
import { ClientsFilter } from "../../../components/filters/ClientsFilter";
import { Filters } from "../../../components/filters/Filters";
import { NavButtons } from "../../../components/navigation/NavButtons";
import { NavigationBar, Right } from "../../../components/styled";
import { setClientsFilter } from "../../../store/filters/filters";
import { useSelector } from "../../../store/hooks";
import { AddLocationButton } from "./AddLocationButton";
import { Search } from "./Search";
import { useTranslation } from "react-i18next";
import { setManageReportsDialog } from "../../../store/usersinsurer";
import { setManageLocationsDialog } from "../../../store/users";
import { SearchResultsCount } from "@greco/components";
import { ExportMenu } from "./ExportMenu";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ClientLocation } from "../../../types/types";
import { CommandBarButton } from "@fluentui/react";
import styled from "styled-components";

type Props = {
  refExcelExport?: ExcelExport;
  filteredLocations?: ClientLocation[];
  visibleLabelKeys?: string[];
  onOpenColumnOptions?: () => void;
  activeFilterCount?: number;
  filteredCount?: number;
};

export const Navigation = ({
  refExcelExport,
  filteredLocations,
  visibleLabelKeys,
  onOpenColumnOptions,
  activeFilterCount = 0,
  filteredCount,
}: Props) => {
  const reduxCount = useSelector((s) => s.locationsPage.shownIds.length);
  const count = filteredCount !== undefined ? filteredCount : reduxCount;
  const dispatch = useDispatch();
  const clientsFilter = useSelector((s) => s.filters.clientsFilter);
  const userRole = useSelector((s) => s.userRole.userRole);
  const { t } = useTranslation();

  return (
    <NavigationBar>
      <NavButtons />
      <Search />
      <Filters>
        <ClientsFilter />
        <ClearFilters
          isDisabled={clientsFilter.length === 0}
          onClear={() => {
            dispatch(setClientsFilter([]));
            dispatch(
              setManageLocationsDialog({
                user: null,
                isOpen: false,
              }),
            );
            dispatch(
              setManageReportsDialog({
                user: null,
                isOpen: false,
              }),
            );
          }}
        />
      </Filters>
      {(userRole === "admin" || userRole === "internal_role") && (
        <AddLocationButton />
      )}
      {refExcelExport && filteredLocations && (
        <ExportMenu
          refExcelExport={refExcelExport}
          filteredLocations={filteredLocations}
          visibleLabelKeys={visibleLabelKeys}
        />
      )}
      <Right>
        {onOpenColumnOptions && (
          <StyledCommandBarButton
            text={t("greco.columnOptions")}
            iconProps={{ iconName: activeFilterCount > 0 ? "FilterSolid" : "Filter" }}
            onClick={onOpenColumnOptions}
          />
        )}
        <SearchResultsCount count={count} label={t("greco.searchResults")} />
      </Right>
    </NavigationBar>
  );
};

const StyledCommandBarButton = styled(CommandBarButton)`
  height: 32px;
`;
